window.lpTag = window.lpTag || {};
lpTag.cookieMethods = lpTag.cookieMethods || (function () {
        "use strict";
        var cookieEnabled = false,
            chromeThirdPartyEnabled = false,
            firstAttempt = true;

        _testForCookies();

        function _isChrome() {
            return ( navigator.userAgent.match(/Chrome/) ? true : false );
        }

        function _testForCookies() {
            var key = "lpTestCookie" + new Date().getTime(),
                value = "testValue";
            _writeSessionCookie({name: key, value: value});
            cookieEnabled = (value === readCookie(key));
            clearCookie(key);
            if (!cookieEnabled && _isChrome()) {
                _testForThirdPartyChrome();
            }
            firstAttempt = false;
            return cookieEnabled;
        }

        function _testForThirdPartyChrome() {
            var key = "lpTestCookie" + new Date().getTime(),
                value = "testValue";
            _writeSessionCookie({name: key, value: value, sameSite: 'none', secure: true});
            chromeThirdPartyEnabled = (value === readCookie(key));
            clearCookie(key, null, null, true, 'none');
            return chromeThirdPartyEnabled;
        }

        /**
         * Returns if we are able to write cookies here
         * @returns {boolean}
         */
        function isCookieEnabled() {
            return cookieEnabled;
        }

        /**
         * Returns if we are able to write cookies here with samesite and secure
         * @returns {boolean}
         */
        function isChromeThirdPartyEnabled() {
            return chromeThirdPartyEnabled;
        }

        /**
         * Reads a cookie from document.cookie (First Party Cookies)
         * @param dataName
         * @returns {string}
         */
        function readCookie(dataName) {
            var arr,
                tempCookies,
                delimiter = "; ",
                res = '';

            if (firstAttempt || cookieEnabled || chromeThirdPartyEnabled) {
                if (typeof dataName !== 'string') {
                    return '';
                }
                dataName = encodeURIComponent(dataName);
                try {
                    tempCookies = delimiter + document.cookie;
                }catch (exc){}
                arr = tempCookies.split(delimiter + dataName + '=');
                if (arr.length == 1) {
                    res = '';
                } else {
                    res = decodeURIComponent(arr[1].split(';')[0]);
                }

            }
            return res;
        }

        /**
         * This method supports an object input as it's first parameter
         * with the following keys or inputs per param (backward compatability )
         * @param name
         * @param value
         * @param seconds
         * @returns {*}
         */
        function writePersistentCookie(name, value, seconds) {
            seconds = typeof seconds == 'number' ? (seconds) : (3600 * 24 * 30);//A ~month in seconds
            if(typeof name === 'object'){
                name.seconds = seconds;
            }
            return writeCookie(name, value, seconds);
        }

        /**
         * This method supports an object input as it's first parameter
         * with the following keys or inputs per param (backward compatability )
         * @param name
         * @param value
         * @param seconds
         * @param path
         * @param domain
         * @param secure
         * @returns {*}
         */
        function writeCookie(name, value, seconds, path, domain, secure, sameSite) {
            if (typeof name === 'object') {
                return _writeSessionCookie(name);
            } else {
                return _writeSessionCookie({
                    name: name,
                    value: value,
                    seconds: seconds,
                    path: path,
                    domain: domain,
                    secure: secure,
                    sameSite: sameSite
                });
            }
        }

        /**
         * Accepts an object containing the following keys
         * name
         * value
         * seconds
         * path
         * domain
         * secure
         * @param options
         * @returns {boolean}
         */
        function _writeSessionCookie(options) {
            var expires,
                now,
                result = false;

            if (firstAttempt || cookieEnabled || (chromeThirdPartyEnabled && options.secure && options.sameSite === 'none')) {
                if (typeof options.name !== 'string' || options.name === '') {
                    return false;
                }
                if (options.value === null || typeof options.value === 'undefined') {
                    options.seconds = -1;
                }
                if (typeof options.seconds === 'number') { //in seconds
                    now = new Date().getTime();
                    expires = new Date(now + (options.seconds * 1000));//From MilliSeconds
                }

                options.value = options.value ? encodeURIComponent(options.value) : '';

                try {
                    document.cookie = [encodeURIComponent(options.name), '=', options.value,
                        (expires ? '; expires=' + expires.toUTCString() : ''),
                        (options.path ? '; path=' + options.path : ''),
                        (options.domain ? '; domain=' + options.domain : ''),
                        (options.secure ? '; secure' : ''),
                        (options.sameSite ? '; samesite=' + options.sameSite : '')].join("");
                    result = true;
                }catch (exc){}
            }
            return result;
        }

        function clearCookie(name, path, domain, secure, sameSite) {
            return _writeSessionCookie( { name : name, path: path, domain: domain, secure: secure, sameSite: sameSite });
        }

        return {
            clearCookie: clearCookie,
            writeSessionCookie: writeCookie,
            writePersistentCookie: writePersistentCookie,
            readCookie: readCookie,
            isCookieEnabled: isCookieEnabled,
            isChromeThirdPartyEnabled: isChromeThirdPartyEnabled
        };
    })();

window.lpTag = window.lpTag || {};
lpTag.storageMethods = lpTag.storageMethods || (function () {
    "use strict";
    var sessionEnabled = false, localEnabled = false;

    function isStorageEnabled() {
        return sessionEnabled && localEnabled;
    }

    function isSessionStorageEnabled() {
        return sessionEnabled;
    }

    function isLocalStorageEnabled() {
        return localEnabled;
    }

    function setSessionData(name, value) {
        if (isSessionStorageEnabled()) {
            sessionStorage.setItem(name, value);
            return true;
        }
    }

    function getSessionData(name) {
        if (isSessionStorageEnabled()) {
            return sessionStorage.getItem(name) || '';
        }
    }

    function removeSessionData(name) {
        if (isSessionStorageEnabled()) {
            if (getSessionData(name)) {
                sessionStorage.removeItem(name);
                return true;
            }
        }
        return false;
    }

    function setPersistentData(name, value) {
        if (isLocalStorageEnabled()) {
            localStorage.setItem(name, value);
            return true;
        }
    }

    function getPersistentData(name) {
        if (isLocalStorageEnabled()) {
            return localStorage.getItem(name) || '';
        }
    }

    function removePersistentData(name) {
        if (isLocalStorageEnabled()) {
            if (getPersistentData(name)) {
                localStorage.removeItem(name);
                return true;
            }
        }
        return false;
    }

    function _init() {
        try {
            sessionEnabled = _testStorage(sessionStorage);
            localEnabled = _testStorage(localStorage);
        }catch (exc){}
    }

    function _testStorage(storageType) {
        var enabled = false, testVar = "lpTestCase", testVal = "abc";
        try {
            if (typeof Storage !== 'undefined') {
                storageType.setItem(testVar, testVal);
                enabled  = (storageType.getItem(testVar) === testVal);
                storageType.removeItem(testVar);
            }
        } catch (e) {
        }
        return enabled;
    }

    _init();

    return {
        isStorageEnabled: isStorageEnabled,
        isSessionStorageEnabled: isSessionStorageEnabled,
        isLocalStorageEnabled: isLocalStorageEnabled,
        setSessionData: setSessionData,
        getSessionData: getSessionData,
        removeSessionData: removeSessionData,
        setPersistentData: setPersistentData,
        getPersistentData: getPersistentData,
        removePersistentData: removePersistentData
    };
})();

window.lpTag = window.lpTag || {};
lpTag.SessionDataManager = lpTag.SessionDataManager || function (config) {
    "use strict";

    var valueSeparator = "::",
        sessionData = {},
        persistentData = {},
        storageMethods,
        cookieMethods,
        that,
        hasLocalStorage,
        configuration = typeof config === 'object' ? config : {};

    if (this === window) {//Only in use if the scope is the new object
        return;
    }

    storageMethods = lpTag.storageMethods;
    cookieMethods = lpTag.cookieMethods;
        /**
         * disableStorage is for allowing users of the API to enforce how it's data is stored
         * It is for cases where the API user wants complete control
         */
    hasLocalStorage = (configuration.disableStorage === true) ? false : storageMethods.isStorageEnabled();
    that = this;

    function log(message) {
        if(lpTag && lpTag.log){
            lpTag.log(message, 'ERROR', 'SessionData');
        }
    }

    function _appendData(key, value, persistence){
        var dataSet = false;
        if(typeof value !== 'object'){
            try{
                var values = persistence ? that.getPersistentSessionData(key) : that.getSessionData(key);
                var valueArray = values !== "" ? values.split(valueSeparator) : [];
                valueArray.push(value);
                values = valueArray.join(valueSeparator);
                dataSet = persistence ? that.setPersistentData(key, values, persistence) : that.setSessionData(key, values);
            }catch(exc){
                log((persistence ? "appendToPersistentData " : "appendToSessionData ") + " failed, key: " + key );
            }
        }
        return dataSet;
    }

    function _removePartialData(key, value, persistence){
        var dataRemoved = false;
        if(typeof value !== 'object'){
            try{
                var values = persistence ? that.getPersistentSessionData(key) : that.getSessionData(key);
                var valueArray = values !== "" ? values.split(valueSeparator) : [];
                var resArray = [];
                for(var i =0; i < valueArray.length; i++){
                    if(valueArray[i] !== value){
                        resArray.push(valueArray[i]);
                    }
                }
                values = resArray.join(valueSeparator);
                if(values !== ""){
                    dataRemoved = persistence ? that.setPersistentData(key, values, persistence) : that.setSessionData(key, values);
                }else{
                    dataRemoved = persistence ? that.removePersistentData(key) : that.removeSessionData(key);
                }
            }catch(exc){
                log((persistence ? "removePartialPersistentData " : "removePartialSessionData ") + " failed, key: " + key );
            }
        }
        return dataRemoved;
    }

    this.readCookie = function (name) {
        return cookieMethods.readCookie(name);
    };

    this.setSessionData = function (key, value) {
        value = this.stringifyValue(value);
        try{
            if(!sessionData[key]){
                sessionData[key] = key;
            }
            if(hasLocalStorage){
                storageMethods.setSessionData(key, value);
            }else{
                cookieMethods.writeSessionCookie(key, value);
            }
        }catch(exc){
            log('Error in setSessionData, data: ' + key );
        }
    };

    this.getSessionData = function(key){
        try{
            return this.parseValue(hasLocalStorage ? storageMethods.getSessionData(key) : cookieMethods.readCookie(key));
        }catch(exc){
            log('Error in getSessionData, data: ' + key );
        }
    };

    this.stringifyValue = function(value){
        try{
            if(typeof  value === 'object'){
                value = JSON.stringify(value);
            }
        }catch(exc) { }
        return value;
    };

    this.parseValue = function(value){ // TODO: Rename to parseValue - adi
        try{
            value = JSON.parse(value);
        }catch(exc) { }

        return value;
    };

    this.getPersistentSessionData = function(key){
        try{
            return this.parseValue(hasLocalStorage ? storageMethods.getPersistentData(key) : cookieMethods.readCookie(key));
        }catch(exc){
            log('Error in getPersistentSessionData, data: ' + key );
        }
    };

    this.appendToSessionData = function(key, value){
        _appendData(key, value, false);
    };

    this.appendToPersistentData = function(key, value, persistence){
        _appendData(key, value, true, persistence);
    };

    this.removePartialPersistentData = function(key, value){
        _removePartialData(key, value, true);
    };

    this.removeSessionData = function(key){
        if (hasLocalStorage) {
            storageMethods.removeSessionData(key);
        } else {
            cookieMethods.clearCookie(key);
        }
    };

    this.removePersistentData = function(key){
        if (hasLocalStorage) {
            storageMethods.removePersistentData(key);
        } else {
            cookieMethods.clearCookie(key);
        }
    };

    this.removePartialSessionData = function(key, value){
        _removePartialData(key, value, false);
    };

    this.setPersistentData = function(key, value, persistence){
        value = this.stringifyValue(value);
        try{
            if(!persistentData[key]){
                persistentData[key] = key;
            }
            if(hasLocalStorage){
                storageMethods.setPersistentData(key, value);
            }else{
                cookieMethods.writePersistentCookie(key, value, persistence);
            }
        }catch(exc){
            log('Error in setPersistentData, data: ' + key );
        }
    };

    this.clearPersistentData = function(dataMap){
        dataMap = dataMap || persistentData;
        for(var key in  dataMap){
            try{
                if(hasLocalStorage){
                    storageMethods.removePersistentData(dataMap[key]);
                }else{
                    cookieMethods.clearCookie(dataMap[key]);
                }
            }catch(exc){
                log('Error in clearPersistentData, key: ' + dataMap[key]);
            }
        }
    };

    this.clearSessionData = function(dataMap){
        dataMap = dataMap || sessionData;
        for(var key in dataMap){
            try{
                if(hasLocalStorage){
                    storageMethods.removeSessionData(dataMap[key]);
                }else{
                    cookieMethods.clearCookie(dataMap[key]);
                }
            }catch(exc){
                log('Error in SessionData in clearSessionData, key:' + dataMap[key]);
            }
        }
    };
};

window.lpTag = window.lpTag || {};
lpTag.taglets = lpTag.taglets || {};
lpTag.utils = lpTag.utils || {};
/**
 * This wrapper allows using secure storage or session storage according to configuration
 * It is instance based
 * @param config
 * @constructor
 */
lpTag.utils.SessionDataAsyncWrapper = lpTag.utils.SessionDataAsyncWrapper || function (config) {
	"use strict";
	if (this === window) {
		return null;
	}
	config = config || {};

	var useSecureStorage = config.useSecureStorage,
		lpNumber = config.lpNumber,
		isSecureStorageEnabled = false,
		appName,
		env,
		secureStorageManager,
		secureStorageLocation,
		firstParty,
		app = config.app || "sessionDataAsyncWrapper";

	if (useSecureStorage) {
		appName = config.appName;
		env = config.env || _getEnv();
		secureStorageManager = (lpTag.taglets && lpTag.taglets.lpSecureStorage);
		secureStorageLocation = config.secureStorageLocation;
		firstParty = config.firstParty;
		isSecureStorageEnabled = useSecureStorage && secureStorageLocation && secureStorageManager && appName && lpNumber ? true : false;
		if (isSecureStorageEnabled) {
			secureStorageManager.configure({
				conf: {
					site: lpNumber,
					env: env,
					app: app,
					url: secureStorageLocation,
					firstParty: firstParty
				}
			});
		}
	}


	if (lpTag.SessionDataManager) {
		lpTag.utils.sessionDataManager = lpTag.utils.sessionDataManager || new lpTag.SessionDataManager(config);
	}
	var storageManager = lpTag.utils.sessionDataManager || null;

	/*********************
	 *  PUBLIC FUNCTIONS
	 *********************/

	/**
	 * Gets a storage value based on callbacks
	 * @param key - the key of the value we want
	 * @param success - the success callback method
	 * @param error - the error callback method
	 * @param context - the execution context of the callback
	 */
	function getStorageData(key, success, error, context) {
		var value;
		if (isSecureStorageEnabled) {
			secureStorageManager.getValue({
				key: key,
				app: app,
				appName: appName,
				site: lpNumber,
				success: _createCallbackForSecureData(key, success, context),
				error: _createCallbackForSecureData(key, error, context),
				context: context,
				domain: secureStorageLocation,
				firstParty: firstParty
			});
		} else {
			value = storageManager.getSessionData(key);
			if (typeof  value !== 'undefined') {
				_runCallBack(success, value, context);
			} else {
				_runCallBack(error, value, context);
			}
		}
	}

	/**
	 * Sets a storage value
	 * @param key
	 * @param value
	 * @param success
	 * @param error
	 * @param context
	 */
	function setStorageData(key, value, success, error, context) {
		if (isSecureStorageEnabled) {
			secureStorageManager.setValue({
				key: key,
				app: app,
				appName: appName,
				value: value,
				site: lpNumber,
				success: _createCallbackForSecureData(key, success, context),
				error: _createCallbackForSecureData(key, error, context),
				context: context,
				domain: secureStorageLocation,
				firstParty: firstParty
			});
		} else {
			if (storageManager.setSessionData(key, value)) {
				_runCallBack(success, true, context);
			} else {
				_runCallBack(error, false, context);
			}
		}
	}

	/**
	 * Removes a storage value
	 * @param key
	 * @param success
	 * @param error
	 * @param context
	 */
	function removeStorageData(key, success, error, context) {
		if (isSecureStorageEnabled) {
			secureStorageManager.setValue({
				key: key,
				app: app,
				appName: appName,
				site: lpNumber,
				success: _createCallbackForSecureData(key, success, context),
				error: _createCallbackForSecureData(key, error, context),
				context: context,
				domain: secureStorageLocation,
				expires: -1,
				firstParty: firstParty
			});
		} else {
			if (storageManager.removeSessionData(key)) {
				_runCallBack(success, true, context);
			} else {
				_runCallBack(error, false, context);
			}
		}
	}

	/*********************
	 *  PRIVATE FUNCTIONS
	 *********************/

	function _getEnv() {
		return (typeof lpTag.getEnv === "function" && lpTag.getEnv());
	}

	/**
	 * Creates a callback for secure storage value
	 * @param key
	 * @param callback
	 * @param context
	 * @return {Function}
	 */
	function _createCallbackForSecureData(key, callback, context) {
		return function (value) {
			_runCallBack(callback, value, context);
		};
	}

	/**
	 * Runs a callback
	 * @param callback
	 * @param data
	 * @param context
	 */
	function _runCallBack(callback, data, context) {
		try {
			if (callback && typeof callback === 'function') {
				callback.call(context, data);
			}
		} catch (exc) {
		}
	}

	//This is the public API of this class
	return {
		setSessionData: setStorageData,
		getSessionData: getStorageData,
		removeSessionData: removeStorageData,
		readCookie: lpTag.utils.sessionDataManager && lpTag.utils.sessionDataManager.readCookie,
		usingSecureStorage: isSecureStorageEnabled
	};
};

window.lpTag = window.lpTag || {};

lpTag.RelManager = lpTag.RelManager || function (transportOrderConfig) {
    "use strict";
    var useJSON = true,
        that = this,
        relStorageObject = null,
        baseUrl = '',
        localConfiguration = { domain: '', lpNumber: '', appKey: '', accessToken: ''},
        transportOrder = ['xhr', 'postmessage', 'rest2jsonp'];

    if (this === window) {
        _log('RelManager called without new', 'DEBUG', 'lpTag.RelManager');
        return new lpTag.RelManager(transportOrderConfig);
    }

    if (transportOrderConfig && transportOrderConfig.constructor === Array) {
        transportOrder = transportOrderConfig;
    }

    /******************** Public Methods **********************/

    /**
     * Clears the configuration and stored rels
     */
    this.clearData = function () {
        for (var key in localConfiguration) {
            if (localConfiguration.hasOwnProperty(key)) {
                localConfiguration[key] = '';
            }
        }
        relStorageObject = null;
        baseUrl = '';
    };

    /**
     * Configure the relManager
     * Configuration data for server :
     * {
     *   domain: 'liveperson.net',
     *   lpNumber: '12340',
     *   appKey: 'asldka78a79sd798asd654as6d9'
     *  }
     * @param config
     */
    this.setData = function (config) {
        relStorageObject = {};
        baseUrl = '';

        if (config) {
            for (var key in config) {
                if (config.hasOwnProperty(key)) {
                    localConfiguration[key] = config[key];
                }
            }
            if (typeof config.useJSON === 'boolean') {
                useJSON = config.useJSON;
            }
            if (config.transportOrder) {
                transportOrder = config.transportOrder;
            }
        }
    };

    /**
     * Adds relative links to our container for future lookup
     * @param linksObject - an array or object of links built as { rel : 'relativeLinkName' , href: 'ServiceURI' }
     * @param storageLocation - { type : 'CHAT', id: 12312 }, id is for multiple instances of the same type
     */
    this.addRels = function (linksObject, storageLocation) {

        var relMapPointer,
            linkName,
            linkValue,
            relsFound;

        if (storageLocation) {
            relsFound = this.extractRels(linksObject);

            relMapPointer = (relStorageObject[storageLocation.type] = relStorageObject[storageLocation.type] || {}); //Make sure we have a parent object
            if (storageLocation.id) {
                relMapPointer = (relMapPointer[storageLocation.id] = relMapPointer[storageLocation.id] || {});
            }
            for (var relativeLink in relsFound) {//Flatten and merge function for existing object
                if (relsFound.hasOwnProperty(relativeLink)) {
                    linkName = relsFound[relativeLink].rel || relsFound[relativeLink]['@rel'];
                    linkValue = relsFound[relativeLink].href || relsFound[relativeLink]['@href'];
                    relMapPointer[linkName] = linkValue;
                }
            }

            if (storageLocation.data) {//Merge function for existing object
                relMapPointer.data = relMapPointer.data || {};
                for (var key in storageLocation.data) {
                    if (storageLocation.data.hasOwnProperty(key)) {
                        relMapPointer.data[key] = storageLocation.data[key];
                    }
                }
            }
        }
    };

    /**
     * Removes a whole rel path from the relStorageObject
     * @param lookUp - { type: 'CHAT', id: 123 }
     * @returns {boolean}
     */
    this.removeRels = function (lookUp) {
        var childFound = false;
        if (lookUp && typeof lookUp.type !== 'undefined') {
            if (relStorageObject[lookUp.type]) {
                if (lookUp.id) {
                    if (relStorageObject[lookUp.type][lookUp.id]) {
                        relStorageObject[lookUp.type][lookUp.id] = null;
                        delete relStorageObject[lookUp.type][lookUp.id];
                        childFound = true;
                    }
                } else {
                    relStorageObject[lookUp.type] = null;
                    delete relStorageObject[lookUp.type];
                    childFound = true;
                }
            }
        }
        return childFound;
    };

    /**
     * Checks if a certain rel exists
     * @param relName
     * @param lookUp
     * @returns {boolean}
     */
    this.hasRel = function (relName, lookUp) {
        return !!(this.getURI(relName, lookUp));
    };

    /**
     * Builds a request object
     * {
     *   rel : 'NamedFunction',
     *   type : 'agent/chat/visitor/etc',
     *   requestType: 'GET/POST/PUT/DELETE',
     *   data: requestData,
     * }
     * @type {_getRequestObject}
     */
    this.buildRequestObj = function(requestObj, newAccessToken) {

        var restObj = {
            url: '',
            method: '',
            headers: '',
            data: ''
        };

        localConfiguration.accessToken = newAccessToken || localConfiguration.accessToken;
        restObj.url = _buildURL(requestObj && requestObj.url, requestObj);
        if (requestObj && requestObj.queryParams && restObj.url) {
            restObj.url += _buildQueryParams(requestObj.queryParams);
        }
        restObj.headers = _setHeaders(requestObj && requestObj.requestType);
        restObj.method = _setMethod(requestObj && requestObj.requestType);
        restObj.transportOrder = (requestObj && requestObj.transportOrder) || transportOrder.slice(0);

        if (requestObj && requestObj.data) {
            restObj.data = requestObj.data;
        }

        if (restObj.url) {
            return restObj;
        } else {
            return null;
        }
    };

    /**
     * Finds the first link object and retruns it
     * @param data
     * @returns {Array}
     */
    this.extractRels = function(data) {

            var relativePaths = [];
            for (var key in data) {
                if (data.hasOwnProperty(key) && relativePaths.length === 0) {
                    if (key === 'link') {
                        relativePaths = data[key].constructor === Array ? data[key] : [data[key]];
                        break;
                    } else if (data[key] !== null && typeof data[key] !== 'undefined' &&
                        typeof data[key] === 'object' && data[key].constructor !== Array) {
                        relativePaths = this.extractRels(data[key]);
                    }
                }
            }
            return relativePaths;
        };

    /**
     * Gets a rel from the relStorageObject
     * based on type -> (id -*optional) -> relName
     * @param relName : 'endChat'
     * @param lookUp - { type: 'CHAT', id: 123 }
     * @returns {*}
     */
    this.getURI = function (relName, lookUp) {

        var resultRel = null,
            relPointer;

        if (lookUp && relStorageObject) {
            relPointer = relStorageObject[lookUp.type];
            if (relPointer && lookUp.id && relPointer[lookUp.id]) {
                relPointer = relPointer[lookUp.id];
            }

            if (relPointer) {
                resultRel = relPointer[relName] || null;
                if (!resultRel && relPointer.data) {//Relational data- chat-> visitor
                    resultRel = _getRelationURI(relName, relPointer);
                }
            }
        }
        return resultRel;
    };

    /******************** Private Methods **********************/

    /**
     * Checks if there was a relationship stored for this rel pointer parent (chat -> visitor and so on
     * @param relName
     * @param relPointer
     * @returns {*}
     * @private
     */
    function _getRelationURI(relName, relPointer) {

        var resultRel;
        for (var key in relPointer.data) {
            if (relPointer.data.hasOwnProperty(key)) {
                resultRel = that.getURI(relName, { type: key, id: relPointer.data[key]});
                if (resultRel) {
                    break;
                }
            }
        }
        return resultRel;
    }

    /**
     * Adds App Server required parameters to the request
     * @param url
     * @returns {*}
     * @private
     */
    function _addAPIRequiredQuery(url) {

        if (url.indexOf('v=1') < 0) {
            url += url.indexOf('?') > -1 ? '&' : '?';
            url += 'v=1';
        }
        if (url.indexOf('&NC=true') < 0) {
            url += '&NC=true';
        }
        return url;
    }

    /**
     * Adds the JSON suffix to the request Urls
     * to make sure our response is JSON
     * @param url
     * @returns {*}
     * @private
     */
    function _addJSONSuffix(url) {

        if (useJSON && url.toLowerCase().indexOf('.json') < 0) {
            var endIndex = url.indexOf('?');
            if (endIndex > 0) {
                url = url.replace('?', '.json?');
            } else {
                url += '.json';
            }
        }
        return url;
    }

    /**
     * Builds the query params generically
     * @param queryParams
     * @returns {string}
     * @private
     */
    function _buildQueryParams(queryParams) {
        var returnedQueryLine = '';
        for (var value in queryParams) {
            if (queryParams.hasOwnProperty(value) &&
                typeof queryParams[value] !== 'undefined' &&
                queryParams[value] !== null) {
                if (queryParams[value].constructor === Array) {
                    for (var i = 0; i < queryParams[value].length; i++) {
                        returnedQueryLine += '&' + encodeURIComponent(value) + '=' + encodeURIComponent(queryParams[value][i]);
                    }
                } else {
                    returnedQueryLine += '&' + encodeURIComponent(value) + '=' + encodeURIComponent(queryParams[value]);
                }
            }
        }
        return returnedQueryLine;
    }

    /**
     * Sets the correct method on the request
     * @param method
     * @returns {*}
     * @private
     */
    function _setMethod(method) {
        if (method === 'PUT' || method === 'DELETE') {
            return 'POST';
        } else {
            return  method || 'GET';
        }
    }

    /**
     * Sets the needed headers on the request
     * @param method
     * @returns {{AUTHORIZATION: string}}
     * @private
     */
    function _setHeaders(method) {

        var authorizationHeader = { 'AUTHORIZATION': 'LivePerson appKey=' + localConfiguration.appKey };   //have to initialize it every time we enter this function.
        if (localConfiguration.accessToken) {
            authorizationHeader = { 'AUTHORIZATION': 'Bearer ' + localConfiguration.accessToken };
        }
        if (method === 'PUT' || method === 'DELETE') {
            authorizationHeader['X-HTTP-Method-Override'] = method;
        }
        return authorizationHeader;
    }

    /**
     * Builds the URL for the request
     * based on the request
     * @param url
     * @param requestObj
     * @returns {*}
     * @private
     */
    function _buildURL(url, requestObj) {
        if (!url) {
            if (!(requestObj && requestObj.rel) && localConfiguration.domain && localConfiguration.lpNumber) {
                url = 'https://' + localConfiguration.domain + '/api/account/' + localConfiguration.lpNumber;
            } else if (requestObj && requestObj.rel) {
                url = that.getURI(requestObj.rel, { type: requestObj.type, id: requestObj.id, needAuth: requestObj.needAuth });
            }
        } else {
            url = requestObj.url;//Needed for forcing passed in URLS for CSDS
        }
        if (url) {
            url = _addJSONSuffix(url);
            url = _addAPIRequiredQuery(url);
        }
        return url;
    }

    /**
     * Logs to lpTag
     * @param msg
     * @param type
     * @param callerName
     * @private
     */
    function _log(msg, type, callerName) {
        if (lpTag && lpTag.utils && lpTag.utils.log) {
            lpTag.utils.log(msg, type, callerName);
        }
    }
};


(function(window){
    "use strict";
    window.lpTag = window.lpTag || {};
    lpTag.taglets = lpTag.taglets || {};
    lpTag.utils = lpTag.utils || {};
    var utils = lpTag.utils;

    function log(message, type, callerName) {
        if (lpTag && lpTag.log) {
            lpTag.log(message, type, callerName);
        }
    }

    utils.runErrorCallback = function(requestObj, data) {
        if (requestObj && requestObj.error) {
            lpTag.utils.runCallback(requestObj.error, requestObj, data);
        }
        data = null;
        requestObj = null;
    };
    //Method for running direct success callbacks supplied to functions
    utils.runSuccessCallback = function(requestObj, data) {
        if (requestObj && requestObj.success) {
            lpTag.utils.runCallback(requestObj.success, requestObj, data);
        }
    };
    //Generic method for running callbacks
    utils.runCallback = function(callback, requestObj, data) {
        if (callback && typeof callback === 'function') {
            try {
                callback.call(requestObj.context || requestObj, data);
            } catch (err) {
                log("Failed to run callback, callback: " + callback + " data: " + data, "error", "lpTag.utils.runCallback");
            }
        }
    };

    /**
     * Gets an array of options to extend and a choice if to stop on the first one
     * @param configs
     * @param extendObj
     * @param firstOnly
     * @returns {*}
     */
    utils.validateAndExtendConfigs = function(configs, extendObj, firstOnly){
        for(var i =0; i < configs.length; i++){
            extendObj = utils.validateAndExtend(configs[i], extendObj);
            if(firstOnly && extendObj.hasOwnProperty(configs[i].prop)){
                break;
            }
        }
        return extendObj;
    };

    /**
     * Validates an object has a property and extends it
     * @param config : {
     *  obj : the object for the lookup
     *  path: where the data sits
     *  type: the validation type
     *  prop: how to extend the original object
     * @param extendObj
     * @returns {*|{}}
     */
    utils.validateAndExtend = function(config, extendObj){
        var data,
            addData = true;

        extendObj = extendObj || {};
        if(config && utils.validateType("object", config)){
            data = utils.getPropertyFromObject(config.obj, config.path, config.defaultValue);
            if(data !== void 0 && data !== null){
                if(config.type){
                    addData = utils.validateType(config.type, data);
                }
                if(addData) {
                    extendObj[config.prop] = data;
                }
            }
        }
        return extendObj;
    };

    /**
     * Runs simple type validation
     * @param type
     * @param value
     * @returns {boolean}
     * @private
     */
    utils.validateType = function(type, value) {
        var valid = false;
        if (type === 'number') {
            valid = !isNaN(value);
        } else if (type === 'array') {
            valid = (value.constructor === Array);
        } else {
            valid = (typeof value === type);
        }
        return valid;
    };

    /**
     * Gets a property from a JSON object
     * @param obj
     * @param path
     * @param defaultValue
     * @returns {*}
     * @private
     */
    utils.getPropertyFromObject = function(obj, path, defaultValue) {
        var pathNames,
            currentLocation = obj;
        if (typeof path === 'string') {
            pathNames = path.split(".");

            for (var i = 0; i < pathNames.length; i++) {
                if (typeof currentLocation !== 'undefined' && currentLocation !== null &&
                    typeof currentLocation[pathNames[i]] !== 'undefined' && currentLocation[pathNames[i]] !== null) {
                    currentLocation = currentLocation[pathNames[i]];
                } else {
                    currentLocation = typeof defaultValue !== 'undefined' ? defaultValue : void 0;
                    break;
                }
            }
        }
        return currentLocation;
    };

    utils.trim = function(val){
        if(typeof val === 'string' && val !== ''){
            val = val.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
        }
        return val;
    };

    utils.getErrorData = function(errorData, message, reqObj, extraParams) {
        errorData = _extractErrorData(errorData, message, reqObj);
        for (var key in extraParams) {
            if (extraParams.hasOwnProperty(key) && !errorData[key]) {
                errorData[key] = extraParams[key];
            }
        }
        extraParams = null;
        return errorData;
    };

    function _extractErrorData(errorInfo, message, reqObj){
        return utils.getPropertyFromObject(errorInfo, "body" ,{ error: { message: message, time: new Date(), originalRequest: reqObj } });
    }

    utils.getResponseData = function(data, parameterName, baseNameParam ,extraParams) {
        var res = utils.getPropertyFromObject(data, "body", {});
        var param, len, keys;
        if (parameterName) {//Get sub parameter
            keys = parameterName.split(".");
            len = keys.length;
            for (var i = 0; i < len; i++) {//This is looping over the possible path of our result
                param = keys[i];
                if (typeof res[param] !== 'undefined') {//We dive into the possible data
                    res = res[param];//Change scope of response
                } else {
                    break;
                }
            }
            if (baseNameParam === true) {
                var finalRes = {};
                finalRes[keys[len - 1]] = res;
                res = finalRes;//Make sure it now indicates what the scope is
            }
        }
        res = utils.removeRels(res);//Clear unwanted links from response
        for (var key in extraParams) {//Attach more data we want to response
            if (extraParams.hasOwnProperty(key) && typeof res[key] === 'undefined') {
                res[key] = extraParams[key];
            }
        }
        return res;
    };

    utils.removeRels = function(obj) {
        for (var key in obj) {
            if (obj.hasOwnProperty(key)) {
                if (key == "link") {
                    obj[key] = null;
                    delete obj[key];
                } else if(typeof obj[key] === 'object') {
                    obj[key] = lpTag.utils.removeRels(obj[key]);
                }
            }
        }
        return obj;
    };

    utils.deleteProps = function(obj, propsArray){
        for(var i =0; i< propsArray.length; i++){
            if(obj.hasOwnProperty(propsArray[i])){
                try{
                    obj[propsArray[i]] = null;
                    delete obj[propsArray[i]];
                }catch (exc){}
            }
        }
    };

    utils.hasProperties = function(obj){
        var hasKey = false;
        if(obj && typeof obj === 'object'){
            for(var key in obj){
                if(obj.hasOwnProperty(key)){
                    hasKey = true;
                    break;
                }
            }
        }
        return hasKey;
    };
})(window);


//////////////////
// WEBPACK FOOTER
// ./node_modules/js2restutils/dist/js2RestUtilsAsync.js
// module id = 172
// module chunks = 0